var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGiveFeedbackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#FC2B6E",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 7.61774V22.3843C21 22.775 20.5718 23.0148 20.2387 22.8105L18.5227 21.7585C18.202 21.5619 17.798 21.5619 17.4773 21.7585L15.8363 22.7646C15.3231 23.0792 14.6769 23.0792 14.1637 22.7646L12.5227 21.7585C12.202 21.5619 11.798 21.5619 11.4773 21.7585L9.76133 22.8105C9.42817 23.0148 9 22.775 9 22.3843V7.61773C9 7.22695 9.42817 6.98722 9.76133 7.19146L11.4773 8.24348C11.798 8.44009 12.202 8.44009 12.5227 8.24348L14.1637 7.2374C14.6769 6.92282 15.3231 6.92282 15.8363 7.2374L17.4773 8.24348C17.798 8.44009 18.202 8.44009 18.5227 8.24348L20.2387 7.19146C20.5718 6.98722 21 7.22695 21 7.61774ZM13.2859 11.7237C13.0196 11.7237 12.8037 11.9556 12.8037 12.2415C12.8037 12.5275 13.0196 12.7593 13.2859 12.7593H16.7144C16.9807 12.7593 17.1966 12.5275 17.1966 12.2415C17.1966 11.9556 16.9807 11.7237 16.7144 11.7237H13.2859ZM12.8037 17.7591C12.8037 17.4731 13.0196 17.2413 13.2859 17.2413H16.7144C16.9807 17.2413 17.1966 17.4731 17.1966 17.7591C17.1966 18.045 16.9807 18.2768 16.7144 18.2768H13.2859C13.0196 18.2768 12.8037 18.045 12.8037 17.7591ZM13.2859 14.4825C13.0196 14.4825 12.8037 14.7143 12.8037 15.0003C12.8037 15.2862 13.0196 15.5181 13.2859 15.5181H16.7144C16.9807 15.5181 17.1966 15.2862 17.1966 15.0003C17.1966 14.7143 16.9807 14.4825 16.7144 14.4825H13.2859Z",
    fill: "#FC2B6E"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiveFeedbackIcon);
export default __webpack_public_path__ + "static/media/GiveFeedbackIcon.6320d44f1064fbb0d15173bf6586c7a5.svg";
export { ForwardRef as ReactComponent };